import React, {useState, useEffect} from 'react'
import { Line } from 'react-chartjs-2';

function BestProduct({getDateFormat, statistics}) {
    const [stats, setStats] = useState([])
    useEffect(() => {
        if (statistics[0].bestProduct[0].totalGain === undefined) {
            for (let i=0; i<statistics.length; i++) {
                for (let z=0; z< statistics[i].bestProduct.length; z++) {
                    statistics[i].bestProduct[z].name = statistics[i].bestProduct[z].name + ` (€${statistics[i].bestProduct[z].price})`
                    statistics[i].bestProduct[z].totalGain = statistics[i].bestProduct[z].counter * +statistics[i].bestProduct[z].price
                }
                setStats(statistics);
            }
        } else {
            setStats(statistics)
        } 
    }, [])

    let getLabels = (bestProduct) => {
        let arr = [];
        bestProduct.map((obj) => {
            arr.push(obj.name);
        });
        return arr;
    }

    let getCounters = (bestProduct) => {
        let arr = [];
        bestProduct.map((obj) => {
            arr.push(obj.counter);
        });
        return arr;
    }

    let getPrices = (bestProduct) => {
        let arr = [];
        bestProduct.map((obj) => {
            arr.push(obj.totalGain);
        });
        return arr;
    }

    let getData = (bestProduct) => {
        return {
            labels: getLabels(bestProduct),
            datasets: [
                {
                    label: (window.location.href.includes('/en')) ? 'Amount of sells' : 'כמות מכירות',
                    data: getCounters(bestProduct),
                    backgroundColor: 'rgba(255,170, 0, 0.7)'
                }
             ,{
                    label: (window.location.href.includes('/en')) ? 'Total Money Gained From This Item' : 'רווח כולל ממוצר זה',
                    data: getPrices(bestProduct),
                    backgroundColor: 'rgba(255,200,100, 0.6)'
                }
            ]
        }
    }


if (window.location.href.includes('/en')) {
    return (
        <div className="chartText">
            {stats.map((product, index) => 
                <React.Fragment key={index}>

                {index==0 ? <div className="titleChart">{getDateFormat(product.timestamp)} - Now</div>
                : <div className="titleChart">{getDateFormat(statistics[index-1].timestamp)} - {getDateFormat(product.timestamp)}</div>}
                <div className="containerBar">
                    <Line
                    data={getData(product.bestProduct)}                       
                    options={{ 
                            tooltips: {
                                mode: 'index'
                            },
                            legend: {
                                labels: {
                                    fontSize: 14
                                }
                            },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    ticks: {
                                        display: product.bestProduct.length > 20 ? false : true
                                    }
                                }]
                            }                       
                            }}
                    />
                </div>

                </React.Fragment>
            )}
        </div>  
    )
}

// Else render it in Hebrew
    return (
        <div className="chartText">
            {stats.map((product, index) => 
                <React.Fragment key={index}>

                {index==0 ? <div className="titleChart">{getDateFormat(product.timestamp)} - עכשיו</div>
                : <div className="titleChart">{getDateFormat(statistics[index-1].timestamp)} - {getDateFormat(product.timestamp)}</div>}
                <div className="containerBar">
                    <Line
                    data={getData(product.bestProduct)}                       
                    options={{ 
                            tooltips: {
                                mode: 'index'
                            },
                            legend: {
                                labels: {
                                    fontSize: 14
                                }
                            },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    ticks: {
                                        display: product.bestProduct.length > 20 ? false : true
                                    }
                                }]
                            }                       
                            }}
                    />
                </div>

                </React.Fragment>
            )}
        </div>
    )
}

export default BestProduct
